/* eslint-disable */
import { Component, Injector } from '@angular/core';
import { BaseRoute } from '../../../shared/components/base.route';

@Component({
  selector: 'fund-account',
  template: require('./fund-account.component.html')
})

export class FundAccountComponent extends BaseRoute {

  constructor(injector: Injector) {
    super(injector);
  }

  ngOnInit() {
    this.allyRoutingErrorSub = this.flowManager.allyRoutingError$.subscribe(bool => {
      this.form.inputs.allyRoutingMessage.showUp = bool;
    });
    this.flowManager.isAllyRoutingError = false;
    if (this.flowManager.hasACHProfile) this.form.buttons.inputs.back.classes += ' hide';
  }

  btnClick(e) {
    // @ TODO Clean this up
    if (e.action === 'next') {
      this.router.navigate(['verify-ach-profile-manual']);
    } else if (e.action === 'fund_later') {
      if (this.flowManager.isAuthed) {
        this.flowManager.ssoToAlly();
      } else {
        this.router.navigate(['/credentials']);
      }
    } else if (e.action === 'back') {
      this.appActions.clearData('FundAccount');
      this.appActions.clearData('Fundingchoices');
      if (this.flowManager.hasDepositAccounts) {
        this.router.navigate(['/funding-choices-streamline']);
      } else {
        this.router.navigate(['/funding-choices']);
      }
    }
  }

  difFundingMethod(event) {
    this.modal.difFunding();
  }

}